import { App } from '../features/home';
import { PageNotFound } from '../features/common';
import homeRoute from '../features/home/route';
import commonRoute from '../features/common/route';
import _ from 'lodash';
import harmWatchRoute from '../features/harmwatch/route';
import topicsRoute from '../features/topics/route';
import landingPageRoute from '../features/landing-page/route';
import sourcesRoute from '../features/sources/route';
import reportsRoute from '../features/reports/route';
import loginRoute from '../features/login/route';
import { Login } from '../features/login';
import userManagementRoute from '../features/user-management/route';
import SignUp from '../features/login/SignUp';
import ResetPassword from '../features/login/ResetPassword';
const childRoutes = [homeRoute, commonRoute, harmWatchRoute, landingPageRoute, topicsRoute, sourcesRoute, reportsRoute, userManagementRoute];

const routes = [
  {
    path: '/login',
    component: Login,
    childRoutes: [...loginRoute],
  },
  {
    path: '/signup',
    component: SignUp,
    childRoutes: [...loginRoute],
  },
  {
    path: '/reset-password',
    component: ResetPassword,
    childRoutes: [...loginRoute],
  },
  {
    path: '/',
    component: App,
    childRoutes: [
      ...childRoutes,
      { path: '*', name: 'Page not found', component: PageNotFound },
    ].filter(r => r.component || (r.childRoutes && r.childRoutes.length > 0)),
  },
];

function handleIndexRoute(route) {
  if (!route.childRoutes || !route.childRoutes.length) {
    return;
  }

  const indexRoute = _.find(route.childRoutes, child => child.isIndex);
  if (indexRoute) {
    const first = { ...indexRoute };
    first.path = '';
    first.exact = true;
    first.autoIndexRoute = true;
    route.childRoutes.unshift(first);
  }
  route.childRoutes.forEach(handleIndexRoute);
}

routes.forEach(handleIndexRoute);
export default routes;



// WEBPACK FOOTER //
// ./src/common/routeConfig.js